import { useCallback } from 'react';

import Ip from '../../models/Engines/Ip';
import EnginesService from '../../services/EnginesService';
import ErrorResponse from '../../types/ErrorResponse';
import ItemResponse from '../../types/ItemResponse';
import useItemQuery from '../useItemQuery';

const useEnginesIpListQuery = () => {
	const fetcher = useCallback(
		async (
			dataSetter: (data: ItemResponse<Ip>) => void,
			errorSetter: (error: ErrorResponse) => void,
			domain: string,
		) => {
			await new EnginesService().ip(domain, dataSetter, errorSetter);
		},
		[],
	);

	return useItemQuery(fetcher);
};

export default useEnginesIpListQuery;
